
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment'
import { PrettyJsonModule } from 'angular2-prettyjson';
import { Observable } from 'rxjs'
import { UserModel, UserActions } from '../core';

import { CustomerModel, } from './models/customer-model';
import { GDSCredentials } from './models/gds-credentials-model';

@Injectable()
export class CustomersService {
  private domainStr: string;
  private BASE_URL: string = environment.baseWebApiUrl + 'api/Customer/';
  private QABASE_URL: string = environment.baseWebApiUrl + 'api/QuickAuditServices/';
  private RIABASE_URL: string = environment.baseWebApiUrl + 'api/RIA/';
  CustomerAccountList: any[];

  constructor(private http: Http, private httpNew: HttpClient) {
    this.domainStr = environment.baseWebApiUrl;
  }

  getCustomerListWithUserCounts() {
    return this.http.get(this.RIABASE_URL + "SecurityGetCustomerListWithUserCounts").pipe(
      map(response => { return response.json(); }));
  }

  getCurrentCustomerCustomerListWithUserCounts() {
    return this.http.get(this.RIABASE_URL + "SecurityGetCurrentCustomersCustomerListWithUserCounts").pipe(
      map(response => { return response.json(); }));
   }

  getUserListingByCustomer(CustomerID: number): Observable<UserModel[]> {
    return this.http.get(this.RIABASE_URL + "SecurityGetUserListingByCustomer?CustomerID=" + CustomerID).pipe(
      map(response => { return response.json() }));
  }

  getUserListingForCurrentCustomer(): Observable<UserModel[]> {
    return this.http.get(this.RIABASE_URL + "SecurityGetCustomersUserListing").pipe(
         map(response => { return response.json() }));
  }

  customerEditorLoadCustomer(customerID: number): Observable<CustomerModel> {
    return this.http.get(this.RIABASE_URL + "CustomerEditorLoadCustomer?customerId=" + customerID).pipe(
      map(response => { return response.json() }),
      map(data => {
        return data as CustomerModel;
      }));
  }
  customerEditorCreateNewCustomer(customer: CustomerModel): Observable<CustomerModel> {
    return this.http.post(this.RIABASE_URL + "CustomerEditorCreateNewCustomer", customer).pipe(
      map(response => { return response.json() }),
      map(data => {
        return data as CustomerModel;
      }));
  }
  customerEditorSaveCustomer(customer: CustomerModel): Observable<boolean> {
    return this.http.post(this.RIABASE_URL + "CustomerEditorSaveCustomer", customer ).pipe(
      map(response => { return response.json() }),
      map(data => {
        return data as boolean; 
      }));
  }
  getCustomersGDSCredentials(): Observable<GDSCredentials> {
    return this.http.post(this.RIABASE_URL + "GetGDSCredentialByCustomerID", {}).pipe(
      map(response => { return response.json() }),
      map(data => {
        return data as GDSCredentials;
      }));

  }
  public GetCustomer():Observable<CustomerModel> {
    let service = 'Get';
    return this.http
      .get(this.BASE_URL + service).pipe(
        map((response) => response.json()),
        map((response) => {
          return response;
        }))
  }

  public UpdateCustomer(customer: CustomerModel) {
    let service = 'Update';
    return this.http
      .post(this.BASE_URL + service, customer);
  }
  public getCustomerAccountList(accountType): Observable<any> {
    let service = 'GetCustomers';
    return this.http
      .get(this.QABASE_URL + service).pipe(
        map((response) => response.json()),
        map(response => {
          this.CustomerAccountList = response.customers;
          if (accountType == "Demand") {
            this.CustomerAccountList = this.CustomerAccountList.filter(item => item.type != "Supply");
          }
          else if (accountType == "Supply") {
            this.CustomerAccountList = this.CustomerAccountList.filter(item => item.type == "Supply");
          }
          return this.CustomerAccountList;
        }));
  }
}
